// extracted by mini-css-extract-plugin
module.exports = {"jobsGrid":"JobsList_jobsGrid__eXqLo"};